import { Component, OnInit } from '@angular/core';
import { Filtering } from '../../../service/filtering/filtering';
import { RequestHandler } from '../../../service/OffService/request-handler';
import { RequestButtonTypes } from '../../../common/components/request-button/request-button.component';
import { DashboardService } from '../../../service/events/dashboard.service';
import { Router } from '@angular/router';
import { BaseView } from '../../base-view';
import { UsuariosApiService } from '../../../service/api/usuarios-api.service';
import { environment } from '../../../../environments/environment';
import { StorageManager } from '../../../common/storage-manager.class';
import { getBackNameCountry } from '../../../common/country';
import { createCsv } from '@fitogest/reactive-form-builder/csv';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { UserApiService } from '../../../service/api/user-api.service';

import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { UserModel } from 'src/app/models/usuarios/user.model';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';

import { UsuariosFormDefinition, type UsuariosFormDefinitionContext } from './usuarios-form/form-control/form-definition';
@Component({
    selector: 'app-usuarios',
    standalone: false,
    templateUrl: './usuarios.component.html',
    styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent extends BaseView<UserModel> implements OnInit {
    public serverUrl = environment.serverUrl;

    public form: UsuariosFormDefinition | null = null;


    public showPerfilUnidades = environment.features.showPerfilUnidades;
    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public canRegister = environment.features.canRegister;
    public btnAnadir = 'Añadir Usuario';

    public filter: Filtering<UserModel> = new Filtering<UserModel>();
    public getRequest: RequestHandler<UserModel[]> = this.usuariosApi.usuariosGET;
    public deleteRequest: RequestHandler<UserModel> = this.usuariosApi.usuariosDELETE;
    public pathToForm = 'usuarios-form';
    public menuItemId = 'usuarios';
    public currentUser = StorageManager.getUser();

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};
    public override model = {} as UserModel;

    public colsCanRegister: ColInterface[] = [
        {
            field: 'nombre', 
            header: 'Nombre', 
            filter: '', 
            width: '12.5rem'
        },
        {
            field: 'nif', 
            header: 'NIF\xa0/\xa0CIF', 
            filter: '',
            width: '8rem'
        },
        {
            field: 'email', 
            header: 'Email', 
            filter: '', 
            width: '8rem'
        },
        {
            field: 'telefono', 
            header: 'Teléfono', 
            filter: '',
            width: '8rem'
        },
        {
            field: 'tipo', 
            header: 'Tipo', 
            filter: '', 
            width: '8rem'
        },
    ];

    public cols: ColInterface[] = [
        {
            field: 'nombre', 
            header: 'Nombre', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'apellidos', 
            header: 'Apellidos', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'tipo_carnet', 
            header: 'Carnet', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'fecha_caducidad', 
            header: 'Caducidad', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'nif', 
            header: 'NIF', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'ropo', 
            header: 'ROPO', 
            filter: '',
            width: '5rem'
        },
        {
            field: 'email', 
            header: 'Email', 
            filter: '',
            width: '5rem'
        }
    ];

    constructor(public usuariosApi: UsuariosApiService,
        public userApi: UserApiService,
        private dashboard: DashboardService,
        private router: Router) {
        super(dashboard, usuariosApi.usuariosGET, usuariosApi.usuariosDELETE);
    }


    public override show(modal: string, data: UserModel): void {
        super.show(modal, data);
        this.setModalForm(modal);
    }

    ngOnInit() {
        this.dashboard.setMenuItem(this.menuItemId);
    }

    public add() {
        this.router.navigate(['dashboard', 'crear-usuario']);
    }

    public edit(data: UserModel) {
        if (data.id === this.currentUser.id) {
            this.dashboard.openProfileDialog();
        } else {
            this.router.navigate(['dashboard', 'editar-usuario', data.id]);
        }
    }

    /**
     * Transforms displayed values without losing the component context when the table invokes it as a callback.
     */
    public globalVisualTransform = (value: string, col: ColInterface, row: TreeNode<UserModel> | UserModel): string => {
        const user = this.resolveUserRow(row);

        if (!user) {
            return value ?? '';
        }

        if (col.field === 'nombre') {
            return [user.nombre, user.apellidos].filter(Boolean).join(' ');
        }

        if (col.field === 'tipo') {
            if (user.tipo === 'comunero' && (this.appName !== 'sequiador' && this.appName !== 'SIEX')) {
                return 'agricultor';
            }
            if (user.rol === 'responsable' && this.appName === 'avafitogest') {
                return 'técnico';
            }
            if (user.rol === 'responsable' && this.appName === 'benibal') {
                return 'asesor';
            }
            if (user.rol === 'admin') {
                return 'admin';
            }
        }

        if (col.field === 'pais' && this.appName === 'manezylozano') {
            return (user.pais ? getBackNameCountry(user.pais) : '') ?? '';
        }

        return value ?? '';
    };

    /**
     * Keeps the conditional style callback bound to the component context for table invocations.
     */
    public globalConditionalStyle = (
        _value: string,
        _col: ColInterface,
        _colGroup: ColInterface[],
        _row: TreeNode<UserModel>
    ): ColStylesInterface => ({});

    public getStatusClass(data: UserModel | null | undefined): string {
        const status = this.resolveAccessPlatformStatus(data);

        if (status === 1) {
            return 'user-status-badge user-status-badge--active';
        }

        if (status === 0) {
            return 'user-status-badge user-status-badge--inactive';
        }

        return 'user-status-badge user-status-badge--pending';
    }

    public getStatusLabel(data: UserModel | null | undefined): string {
        const status = this.resolveAccessPlatformStatus(data);

        if (status === 1) {
            return 'Activo';
        }

        if (status === 0) {
            return 'Inactivo';
        }

        return 'Pendiente';
    }

    public resolveAccessPlatformStatus(data: UserModel | null | undefined): number {
        const parsedStatus = Number(data?.acceso_plataforma);

        return Number.isFinite(parsedStatus) ? parsedStatus : 2;
    }

    public toggleActive(data: UserModel) {
        if (confirm('¿Desea activar/desactivar este usuario? \n Este será notificado de ello por email.')) {
            if (data && data.acceso_plataforma) {
                if (data.acceso_plataforma === '2') {
                    data.acceso_plataforma = '1'; // Activo
                } else if (data.acceso_plataforma === '1') {
                    data.acceso_plataforma = '0'; // Inactivo
                } else {
                    data.acceso_plataforma = '1'; // Activo
                }
            }

            this.userApi.sendEmailConfirmation({
                usuario: data.username,
                email: data.email,
                estado: data.acceso_plataforma
            } as UserModel).then(res => {
                console.log(res);
                return;
            }
            ).catch (e => {
                console.log('catch en sendEmailConfirmation: ' + e);
            }
            );

            this.usuariosApi.usuariosPUT.perform({
                id: data.id,
                id_state: data.acceso_plataforma
            } as never);
            this.usuariosApi.usuariosPUT.response(res => {
                const respuesta: unknown = res;
                if ((respuesta as Response).status === 200) {
                    console.log('Success!');
                }
            });

        }
    }

    public async exportarUsuarios() {
        window.location.replace(environment.serverUrl + 'fito_backup/exportar_usuarios.php');
    }

    public downloadCsv(): void {
        const csvDefinition = new UsuariosFormDefinition(
            FormType.EXPORT,
            this.filter.value as unknown as Partial<UserModel>,
            this.createFormDefinitionContext()
        );
        const csvContent = createCsv(
            csvDefinition.fieldNames,
            csvDefinition.fieldLabels,
            this.filter.value as UserModel[]
        );
        let csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (!csvLink) {
            csvLink = Object.assign(document.createElement('a'), { style: 'display:none' });
            document.body.appendChild(csvLink);
        }

        csvLink.download = 'Usuarios.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();

        if (!csvLink.id) {
            csvLink.remove();
        }
    }

    private createFormDefinitionContext(): UsuariosFormDefinitionContext {
        return {
            appName: this.appName,
            applicationType: this.applicationType,
            canRegister: this.canRegister,
            clienteName: environment.features.clienteName,
            showPerfilUnidades: this.showPerfilUnidades,
        };
    }

    private resolveUserRow(row: TreeNode<UserModel> | UserModel): UserModel | null {
        return ((row as TreeNode<UserModel>).data ?? row ?? null) as UserModel | null;
    }

    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new UsuariosFormDefinition(formType, this.model, this.createFormDefinitionContext(), 'summary');
    }
}
